let ajax = {
    createXHR: function () {
        if (window.XMLHttpRequest) {
            return new XMLHttpRequest()
        }
    },
    $http: function ({
        type = 'get',
        isAsync = 'true',
        url = '',
        data = {},
        dataType = 'json',
        // header = {
        //     'Content-Type': 'application/x-www-form-rulencoded'
        // }
    }) {
        if (!url) {
            return Promise.reject('请求路径无效')
        }
        // 用我们封装的方法动态生成XHR对象
        let xhr = this.createXHR()
        let str = ''
        // 拼接字符串
        Object.keys(data).forEach(key => str += `${key}=${data[key]}&`)
        str = str.slice(0, -1)
        // 如果是get请求就把携带参数拼接到url后面
        if (type === 'get') url += `?${str}`;
        // 返回promise对象，便于外部then和catch函数调用
        return new Promise((resolve, reject) => {
            // 创建请求
            xhr.open(type, url, isAsync)
            // xhr.setRequestHeader('withCredentials', true)
            if (type === 'post') {
                xhr.setRequestHeader('Content-Type', 'application/json')
                xhr.send(JSON.stringify(data))
            } else {
                xhr.send()
            }

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304) {
                        let res = dataType === 'json' ? JSON.parse(xhr.responseText) : xhr.responseText
                        resolve(res) // 请求成功，返回数据
                    } else {
                        reject(xhr.status) // 请求失败，返回状态码
                    }
                }
            }
        })
    }
}

export default ajax